import React from "react";
import {
    GiftingVerticalLineContainer,
    GiftingBowTieLineContainer,
    GiftingBowTieImageWrapper,
    GiftingBowTieLineImage,
} from "../styles/CartSavingsBannerOneline.style";
import { GIFTING_CART } from "../constants";

export const GiftingCartBowTieLine = () => {
    return (
        <GiftingVerticalLineContainer>
            <GiftingBowTieLineContainer>
                <GiftingBowTieImageWrapper>
                    <GiftingBowTieLineImage cloudinaryId={GIFTING_CART.BOW_TIE} fit="contain" />
                </GiftingBowTieImageWrapper>
            </GiftingBowTieLineContainer>
        </GiftingVerticalLineContainer>
    );
};
